<template>
    <v-row justify="center">
        <v-dialog v-model="internalDialog" persistent max-width="960">
            <v-card>
                <v-toolbar color="primary">
                    <v-icon dark>mdi-email-fast</v-icon>
                    <div style="color: white; margin-left: 10px;" class="text-h6">{{ title }}</div>
                </v-toolbar>

                <v-card-text class="pt-6">
                    <v-form ref="formEnvio" v-model="internalFormValid">
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    :value="tipoDestinatario"
                                    :items="tiposDestinatarioItems"
                                    item-text="text"
                                    item-value="value"
                                    :label="tipoDestinatarioLabel"
                                    :rules="tipoDestinatarioRules"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    @input="handleTipoDestinatarioUpdate"
                                ></v-select>
                            </v-col>
                        </v-row>

                        <template v-if="isPassageiros">
                            <div class="text-subtitle-2 mb-2 grey--text text--darken-1">
                                {{ filtersSectionLabel }}
                            </div>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <multipla-escolha
                                        :key="'envio-grupos'"
                                        ref="gruposSelect"
                                        lazy
                                        get-url="getGruposlazy"
                                        text="nome"
                                        value="id_grupo"
                                        :label="groupsLabel"
                                        can-toggle-all
                                        :all-matching-selected="gruposAllMatching"
                                        @update:selectedItems="handleGruposUpdate"
                                        @update:allMatchingSelected="handleGruposAllMatching"
                                        :rules="groupsRules"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <multipla-escolha
                                        :key="'envio-unidades'"
                                        ref="unidadesSelect"
                                        lazy
                                        get-url="getUnidadeslazy"
                                        text="descricao_unidade"
                                        value="id_unidade"
                                        :label="unitsLabel"
                                        can-toggle-all
                                        :all-matching-selected="unidadesAllMatching"
                                        @update:selectedItems="handleUnidadesUpdate"
                                        @update:allMatchingSelected="handleUnidadesAllMatching"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <multipla-escolha
                                        :key="'envio-clientes-passageiros'"
                                        ref="clientesPassageirosSelect"
                                        lazy
                                        get-url="getClienteslazy"
                                        text="nome_cliente"
                                        value="id_cliente"
                                        :label="clientsLabel"
                                        can-toggle-all
                                        :all-matching-selected="clientesPassageirosAllMatching"
                                        @update:selectedItems="handleClientesPassageirosUpdate"
                                        @update:allMatchingSelected="handleClientesPassageirosAllMatching"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <multipla-escolha
                                        :key="'envio-agencias-passageiros'"
                                        ref="agenciasPassageirosSelect"
                                        lazy
                                        get-url="getAgenciasempregolazy"
                                        text="nome"
                                        value="id_agencia_emprego"
                                        :label="agenciesLabel"
                                        can-toggle-all
                                        :all-matching-selected="agenciasPassageirosAllMatching"
                                        @update:selectedItems="handleAgenciasPassageirosUpdate"
                                        @update:allMatchingSelected="handleAgenciasPassageirosAllMatching"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <multipla-escolha
                                        :key="'envio-pessoas'"
                                        ref="pessoasSelect"
                                        lazy
                                        get-url="getPessoaslazy"
                                        :request-data="pessoasLazyRequestData"
                                        text="nome_completo"
                                        value="id_pessoa"
                                        :label="receiversLabel"
                                        can-toggle-all
                                        :disabled="!hasGruposSelection"
                                        :rules="receiversRules"
                                        @update:selectedItems="handlePessoasUpdate"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                            </v-row>
                        </template>

                        <template v-else>
                            <div class="text-subtitle-2 mb-2 grey--text text--darken-1">
                                {{ filtersSectionLabel }}
                            </div>
                            <v-row dense>
                                <v-col cols="12" sm="4">
                                    <multipla-escolha
                                        :key="'envio-perfis'"
                                        ref="perfisSelect"
                                        :items="perfisItems"
                                        text="descricao_tipo_usuario_translated"
                                        value="id_perfil_usuario"
                                        :label="profilesLabel"
                                        can-toggle-all
                                        @update:selectedItems="handlePerfisUpdate"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <multipla-escolha
                                        :key="'envio-clientes-usuarios'"
                                        ref="clientesUsuariosSelect"
                                        lazy
                                        get-url="getClienteslazy"
                                        text="nome_cliente"
                                        value="id_cliente"
                                        :label="clientsLabel"
                                        can-toggle-all
                                        :all-matching-selected="clientesUsuariosAllMatching"
                                        @update:selectedItems="handleClientesUsuariosUpdate"
                                        @update:allMatchingSelected="handleClientesUsuariosAllMatching"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <multipla-escolha
                                        :key="'envio-agencias-usuarios'"
                                        ref="agenciasUsuariosSelect"
                                        lazy
                                        get-url="getAgenciasempregolazy"
                                        text="nome"
                                        value="id_agencia_emprego"
                                        :label="agenciesLabel"
                                        can-toggle-all
                                        :all-matching-selected="agenciasUsuariosAllMatching"
                                        @update:selectedItems="handleAgenciasUsuariosUpdate"
                                        @update:allMatchingSelected="handleAgenciasUsuariosAllMatching"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <multipla-escolha
                                        :key="'envio-usuarios'"
                                        ref="usuariosSelect"
                                        lazy
                                        get-url="getUsuariosparamensagens"
                                        :request-data="usuariosLazyRequestData"
                                        text="display_text"
                                        value="id_usuario"
                                        :label="usuariosLabel"
                                        can-toggle-all
                                        :rules="receiversRules"
                                        @update:selectedItems="handleUsuariosUpdate"
                                        @error="handleError"
                                    ></multipla-escolha>
                                </v-col>
                            </v-row>
                        </template>

                        <v-row>
                            <v-col cols="12">
                                <v-alert
                                    v-if="canaisFiltrados.length === 0"
                                    type="warning"
                                    dense
                                    outlined
                                    text
                                >
                                    {{ noChannelsMessage }}
                                </v-alert>
                                <multipla-escolha
                                    v-else
                                    :items="canaisFiltrados"
                                    ref="canaisSelect"
                                    text="descricao_canal"
                                    value="id_canal"
                                    :label="channelsLabel"
                                    can-toggle-all
                                    @update:selectedItems="handleCanaisUpdate"
                                    @error="handleError"
                                ></multipla-escolha>
                            </v-col>
                        </v-row>
                        <v-row v-if="canaisSelected.includes(4)">
                            <v-col cols="12" sm="6">
                                <v-checkbox
                                    :value="enviaMensagemDireta"
                                    @input="$emit('update:enviaMensagemDireta', $event)"
                                    color="primary"
                                    :label="directMessagesLabel"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox
                                    :value="enviaMensagemEspaco"
                                    @input="$emit('update:enviaMensagemEspaco', $event)"
                                    color="primary"
                                    :label="spaceMessagesLabel"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row v-if="enviaMensagemEspaco">
                            <v-col cols="12">
                                <multipla-escolha
                                    :items="spaces"
                                    ref="spacesSelect"
                                    text="displayName"
                                    value="spaceId"
                                    :label="spacesLabel"
                                    can-toggle-all
                                    @update:selectedItems="handleSpacesUpdate"
                                    @error="handleError"
                                    :rules="spacesRules"
                                ></multipla-escolha>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="white--text"
                        :disabled="isSending"
                        @click="handleCancel"
                    >{{ cancelText }}</v-btn>
                    <v-btn
                        color="primary"
                        class="white--text"
                        :loading="isSending"
                        @click="handleSend"
                    >{{ sendText }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import MultiplaEscolha from '../Selects/MultiplaEscolha.vue';
import apiController from '@/utils/apiController';
import translateDbField from '@/utils/translateDbField';

export default {
    name: 'EnvioDialog',
    components: {
        MultiplaEscolha
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Enviar Mensagem'
        },
        tipoDestinatario: {
            type: String,
            default: 'passageiros',
            validator: (v) => ['passageiros', 'usuarios'].includes(v),
        },
        tipoDestinatarioLabel: {
            type: String,
            default: 'Tipo de destinatário',
        },
        tiposDestinatarioItems: {
            type: Array,
            default: () => [
                { text: 'Passageiros', value: 'passageiros' },
                { text: 'Usuários', value: 'usuarios' },
            ],
        },
        tipoDestinatarioRules: {
            type: Array,
            default: () => [],
        },
        gruposSelected: {
            type: Array,
            default: () => []
        },
        pessoasSelected: {
            type: Array,
            default: () => []
        },
        usuariosSelected: {
            type: Array,
            default: () => []
        },
        usuariosLabel: {
            type: String,
            default: 'Usuários',
        },
        canais: {
            type: Array,
            default: () => []
        },
        canaisSelected: {
            type: Array,
            default: () => []
        },
        template: {
            type: Object,
            default: null
        },
        spaces: {
            type: Array,
            default: () => []
        },
        spacesSelected: {
            type: Array,
            default: () => []
        },
        enviaMensagemDireta: {
            type: Boolean,
            default: false
        },
        enviaMensagemEspaco: {
            type: Boolean,
            default: false
        },
        groupsLabel: {
            type: String,
            default: 'Grupos'
        },
        unitsLabel: {
            type: String,
            default: 'Unidades'
        },
        clientsLabel: {
            type: String,
            default: 'Clientes'
        },
        agenciesLabel: {
            type: String,
            default: 'Agências'
        },
        profilesLabel: {
            type: String,
            default: 'Perfis'
        },
        filtersSectionLabel: {
            type: String,
            default: 'Filtros'
        },
        receiversLabel: {
            type: String,
            default: 'Destinatários'
        },
        channelsLabel: {
            type: String,
            default: 'Outros Canais'
        },
        noChannelsMessage: {
            type: String,
            default: 'Nenhum canal de comunicação está habilitado no sistema. Configure os canais em Configurações.'
        },
        directMessagesLabel: {
            type: String,
            default: 'Enviar Mensagens Diretas'
        },
        spaceMessagesLabel: {
            type: String,
            default: 'Enviar Mensagens em Espaços'
        },
        spacesLabel: {
            type: String,
            default: 'Espaços do Google Chat'
        },
        cancelText: {
            type: String,
            default: 'Cancelar'
        },
        sendText: {
            type: String,
            default: 'Enviar'
        },
        groupsRules: {
            type: Array,
            default: () => []
        },
        receiversRules: {
            type: Array,
            default: () => []
        },
        spacesRules: {
            type: Array,
            default: () => []
        },
        formValid: {
            type: Boolean,
            default: false
        },
        /** Parent-driven loading (API / scheduler). Combined with local resolve phase. */
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        gruposAllMatching: false,
        unidadesSelected: [],
        unidadesAllMatching: false,
        clientesPassageirosSelected: [],
        clientesPassageirosAllMatching: false,
        agenciasPassageirosSelected: [],
        agenciasPassageirosAllMatching: false,
        perfisSelected: [],
        clientesUsuariosSelected: [],
        clientesUsuariosAllMatching: false,
        agenciasUsuariosSelected: [],
        agenciasUsuariosAllMatching: false,
        perfisItems: [],
        perfisLoaded: false,
        resolvingLazy: false,
        resolvingSend: false,
    }),
    computed: {
        isSending() {
            return !!(this.loading || this.resolvingSend);
        },
        internalDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        internalFormValid: {
            get() {
                return this.formValid;
            },
            set(value) {
                this.$emit('update:formValid', value);
            }
        },
        isPassageiros() {
            return this.tipoDestinatario === 'passageiros';
        },
        hasGruposSelection() {
            return this.gruposAllMatching
                || (Array.isArray(this.gruposSelected) && this.gruposSelected.length > 0);
        },
        pessoasLazyRequestData() {
            return this.buildPessoasFilterRequestData();
        },
        usuariosLazyRequestData() {
            return this.buildUsuariosFilterRequestData();
        },
        canaisFiltrados() {
            const temTemplateMetaValido = this.template &&
                                         this.template.id_template_meta !== null &&
                                         this.template.id_template_meta !== undefined;
            if (!temTemplateMetaValido) {
                return this.canais.filter(canal => canal.id_canal !== 5);
            }
            return this.canais;
        }
    },
    watch: {
        value(open) {
            if (open && !this.isPassageiros) {
                this.ensurePerfisLoaded();
            }
        },
        tipoDestinatario(val) {
            if (val === 'usuarios') {
                this.ensurePerfisLoaded();
            }
        },
    },
    methods: {
        ensurePerfisLoaded() {
            if (this.perfisLoaded) return;
            apiController.request(apiController.endpoints.getallPerfisusuarios, {
                silent: true,
                onSuccess: (response) => {
                    const rows = Array.isArray(response.data) ? response.data : [];
                    this.perfisItems = rows.map((perfil) => ({
                        ...perfil,
                        descricao_tipo_usuario_translated: translateDbField(
                            perfil.translation_key,
                            perfil.descricao_tipo_usuario
                        ),
                    }));
                    this.perfisLoaded = true;
                },
            });
        },
        appendOptionalIds(target, key, ids, allMatching) {
            if (allMatching) return;
            if (Array.isArray(ids) && ids.length > 0) {
                target[key] = ids;
            }
        },
        buildPessoasFilterRequestData(overrides) {
            const opts = overrides || {};
            const data = {};
            // Com "Todos" nos grupos, não envia id_grupos:[] (API trata como vazio).
            // No confirm, resolveSelection força id_grupos com os IDs hidratados.
            if (opts.id_grupos != null) {
                data.id_grupos = opts.id_grupos;
            } else if (!this.gruposAllMatching) {
                data.id_grupos = Array.isArray(this.gruposSelected) ? this.gruposSelected : [];
            }
            this.appendOptionalIds(
                data,
                'id_unidades',
                opts.id_unidades != null ? opts.id_unidades : this.unidadesSelected,
                opts.unidadesAllMatching != null ? opts.unidadesAllMatching : this.unidadesAllMatching
            );
            this.appendOptionalIds(
                data,
                'id_clientes',
                opts.id_clientes != null ? opts.id_clientes : this.clientesPassageirosSelected,
                opts.clientesAllMatching != null
                    ? opts.clientesAllMatching
                    : this.clientesPassageirosAllMatching
            );
            this.appendOptionalIds(
                data,
                'id_agencias_emprego',
                opts.id_agencias_emprego != null
                    ? opts.id_agencias_emprego
                    : this.agenciasPassageirosSelected,
                opts.agenciasAllMatching != null
                    ? opts.agenciasAllMatching
                    : this.agenciasPassageirosAllMatching
            );
            return data;
        },
        buildUsuariosFilterRequestData(overrides) {
            const opts = overrides || {};
            const data = {};
            this.appendOptionalIds(
                data,
                'id_perfis',
                opts.id_perfis != null ? opts.id_perfis : this.perfisSelected,
                false
            );
            this.appendOptionalIds(
                data,
                'id_clientes',
                opts.id_clientes != null ? opts.id_clientes : this.clientesUsuariosSelected,
                opts.clientesAllMatching != null
                    ? opts.clientesAllMatching
                    : this.clientesUsuariosAllMatching
            );
            this.appendOptionalIds(
                data,
                'id_agencias_emprego',
                opts.id_agencias_emprego != null
                    ? opts.id_agencias_emprego
                    : this.agenciasUsuariosSelected,
                opts.agenciasAllMatching != null
                    ? opts.agenciasAllMatching
                    : this.agenciasUsuariosAllMatching
            );
            return data;
        },
        clearPessoasSelection() {
            if (this.resolvingLazy) return;
            this.$emit('update:pessoasSelected', []);
            if (this.$refs.pessoasSelect) {
                this.$refs.pessoasSelect.resetData();
            }
        },
        clearUsuariosSelection() {
            if (this.resolvingLazy) return;
            this.$emit('update:usuariosSelected', []);
            if (this.$refs.usuariosSelect) {
                this.$refs.usuariosSelect.resetData();
            }
        },
        handleTipoDestinatarioUpdate(value) {
            this.$emit('update:tipoDestinatario', value);
            this.$emit('tipoDestinatarioChanged', value);
        },
        handleGruposAllMatching(val) {
            this.gruposAllMatching = !!val;
        },
        handleGruposUpdate(value) {
            this.$emit('update:gruposSelected', value);
            this.clearPessoasSelection();
        },
        handleUnidadesAllMatching(val) {
            if (this.unidadesAllMatching === !!val) return;
            this.unidadesAllMatching = !!val;
            this.clearPessoasSelection();
        },
        handleUnidadesUpdate(value) {
            this.unidadesSelected = Array.isArray(value) ? value : [];
            this.clearPessoasSelection();
        },
        handleClientesPassageirosAllMatching(val) {
            if (this.clientesPassageirosAllMatching === !!val) return;
            this.clientesPassageirosAllMatching = !!val;
            this.clearPessoasSelection();
        },
        handleClientesPassageirosUpdate(value) {
            this.clientesPassageirosSelected = Array.isArray(value) ? value : [];
            this.clearPessoasSelection();
        },
        handleAgenciasPassageirosAllMatching(val) {
            if (this.agenciasPassageirosAllMatching === !!val) return;
            this.agenciasPassageirosAllMatching = !!val;
            this.clearPessoasSelection();
        },
        handleAgenciasPassageirosUpdate(value) {
            this.agenciasPassageirosSelected = Array.isArray(value) ? value : [];
            this.clearPessoasSelection();
        },
        handlePerfisUpdate(value) {
            this.perfisSelected = Array.isArray(value) ? value : [];
            this.clearUsuariosSelection();
        },
        handleClientesUsuariosAllMatching(val) {
            if (this.clientesUsuariosAllMatching === !!val) return;
            this.clientesUsuariosAllMatching = !!val;
            this.clearUsuariosSelection();
        },
        handleClientesUsuariosUpdate(value) {
            this.clientesUsuariosSelected = Array.isArray(value) ? value : [];
            this.clearUsuariosSelection();
        },
        handleAgenciasUsuariosAllMatching(val) {
            if (this.agenciasUsuariosAllMatching === !!val) return;
            this.agenciasUsuariosAllMatching = !!val;
            this.clearUsuariosSelection();
        },
        handleAgenciasUsuariosUpdate(value) {
            this.agenciasUsuariosSelected = Array.isArray(value) ? value : [];
            this.clearUsuariosSelection();
        },
        handlePessoasUpdate(value) {
            this.$emit('update:pessoasSelected', value);
        },
        handleUsuariosUpdate(value) {
            this.$emit('update:usuariosSelected', value);
        },
        handleCanaisUpdate(value) {
            this.$emit('update:canaisSelected', value);
        },
        handleSpacesUpdate(value) {
            this.$emit('update:spacesSelected', value);
        },
        handleError(error) {
            this.$emit('error', error);
        },
        handleCancel() {
            if (this.isSending) return;
            this.$emit('cancel');
        },
        /**
         * Hidrata IDs dos selects lazy com "Todos" (all matching) antes de enviar.
         * Resolve ambos os selects de passageiros antes de emitir, para não limpar
         * o modo all-matching ao atualizar o filtro de grupos.
         * @returns {Promise<{ grupos?: Array, pessoas?: Array, usuarios?: Array }>}
         */
        async resolveLazySelections() {
            const out = {};
            this.resolvingLazy = true;
            try {
                if (this.isPassageiros) {
                    if (this.$refs.gruposSelect && typeof this.$refs.gruposSelect.resolveSelection === 'function') {
                        out.grupos = await this.$refs.gruposSelect.resolveSelection();
                    }
                    if (this.$refs.pessoasSelect && typeof this.$refs.pessoasSelect.resolveSelection === 'function') {
                        const pessoasOpts = {
                            requestData: this.buildPessoasFilterRequestData(
                                out.grupos ? { id_grupos: out.grupos } : {}
                            ),
                        };
                        out.pessoas = await this.$refs.pessoasSelect.resolveSelection(pessoasOpts);
                    }
                    if (out.grupos) {
                        this.$emit('update:gruposSelected', out.grupos);
                    }
                    if (out.pessoas) {
                        this.$emit('update:pessoasSelected', out.pessoas);
                    }
                } else if (this.$refs.usuariosSelect && typeof this.$refs.usuariosSelect.resolveSelection === 'function') {
                    out.usuarios = await this.$refs.usuariosSelect.resolveSelection({
                        requestData: this.buildUsuariosFilterRequestData(),
                    });
                    this.$emit('update:usuariosSelected', out.usuarios);
                }
                return out;
            } finally {
                this.resolvingLazy = false;
            }
        },
        async handleSend() {
            if (this.isSending) return;
            this.resolvingSend = true;
            this.$emit('update:loading', true);
            try {
                await this.resolveLazySelections();
            } catch (_err) {
                this.resolvingSend = false;
                this.$emit('update:loading', false);
                return;
            }
            this.resolvingSend = false;
            this.$emit('send');
        },
        validate() {
            return this.$refs.formEnvio.validate();
        },
        resetValidation() {
            if (this.$refs.formEnvio) {
                this.$refs.formEnvio.resetValidation();
            }
        },
        resetSelects() {
            this.gruposAllMatching = false;
            this.unidadesSelected = [];
            this.unidadesAllMatching = false;
            this.clientesPassageirosSelected = [];
            this.clientesPassageirosAllMatching = false;
            this.agenciasPassageirosSelected = [];
            this.agenciasPassageirosAllMatching = false;
            this.perfisSelected = [];
            this.clientesUsuariosSelected = [];
            this.clientesUsuariosAllMatching = false;
            this.agenciasUsuariosSelected = [];
            this.agenciasUsuariosAllMatching = false;
            this.resolvingSend = false;
            const refs = [
                'gruposSelect',
                'unidadesSelect',
                'clientesPassageirosSelect',
                'agenciasPassageirosSelect',
                'pessoasSelect',
                'perfisSelect',
                'clientesUsuariosSelect',
                'agenciasUsuariosSelect',
                'usuariosSelect',
                'canaisSelect',
                'spacesSelect',
            ];
            refs.forEach((name) => {
                const ref = this.$refs[name];
                if (ref && typeof ref.resetData === 'function') {
                    ref.resetData();
                }
            });
        }
    }
}
</script>
